export default "__VITE_ASSET__j6yRipuE__"